import { render, staticRenderFns } from "./Rtmp.vue?vue&type=template&id=54f7f3c2&scoped=true&"
import script from "./Rtmp.vue?vue&type=script&lang=js&"
export * from "./Rtmp.vue?vue&type=script&lang=js&"
import style0 from "./Rtmp.vue?vue&type=style&index=0&id=54f7f3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f7f3c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54f7f3c2')) {
      api.createRecord('54f7f3c2', component.options)
    } else {
      api.reload('54f7f3c2', component.options)
    }
    module.hot.accept("./Rtmp.vue?vue&type=template&id=54f7f3c2&scoped=true&", function () {
      api.rerender('54f7f3c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/session/item/Rtmp.vue"
export default component.exports